import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Star, Map } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users size={14} data-id="element-202" />,
    value: '+300',
    label: 'nutricionistas ya lo usan'
  }, {
    icon: <BookOpen size={14} data-id="element-203" />,
    value: '6+',
    label: 'Tomos + Bonos'
  }, {
    icon: <Star size={14} data-id="element-204" />,
    value: '4.9/5',
    label: 'calificación'
  }, {
    icon: <Map size={14} data-id="element-205" />,
    value: '🇦🇷',
    label: 'En todo el país'
  }];
  return <section className="relative py-3 px-4" data-id="element-206">
      <div className="max-w-3xl mx-auto" data-id="element-207">
        <div className="relative bg-surface/80 backdrop-blur-sm border border-mint/20 rounded-xl py-3 px-3 md:px-5 shadow-md shadow-black/20 overflow-hidden" data-id="element-208">
          <div className="absolute inset-0 pointer-events-none opacity-60" style={{
          background: 'radial-gradient(ellipse at 50% 0%, rgba(74,222,128,0.10) 0%, transparent 60%)'
        }} data-id="element-209" />

          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-1" data-id="element-210">
            {stats.map((stat, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 6
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: idx * 0.06
          }} className={`flex flex-col items-center justify-center text-center px-1 ${idx > 0 ? 'md:border-l md:border-mint/15' : ''}`} data-id="element-211">
                <div className="w-6 h-6 rounded-md bg-mint/10 border border-mint/20 flex items-center justify-center text-mint mb-1" data-id="element-212">
                  {stat.icon}
                </div>
                <span className="font-[900] font-['Open_Sans',_sans-serif] text-base md:text-lg text-dark leading-none" data-id="element-213">
                  {stat.value}
                </span>
                <span className="mt-0.5 text-[10px] md:text-xs text-dark/60 font-medium leading-tight" data-id="element-214">
                  {stat.label}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}